export default s => {
	if (typeof s !== 'string') {
		return undefined;
	}
	return s.trim().toUpperCase() || undefined;
};
